const colors = {
  primary: '#6DA305', // Основний колір
  secondary: 'rgb(251, 186, 0)', // Додатковий колір
  success: '#28a745', // Колір успіху
  danger: 'red', // Колір помилки
  warning: '#ffc107', // Попередження
  info: '#17a2b8', // Інформаційний
  light: '#f8f9fa', // Світлий фон
  dark: '#343a40', // Темний фон
  customBackground: '#f5f5f5', // Користувацький колір
  textPrimary: '#212529', // Основний текст
  textSecondary: '#6c757d', // Додатковий текст
};

export default colors;
